/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-vars */
/* eslint-disable dot-notation */

import React from 'react';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import CurrencySign from 'components/price/CurrencySign.component';
import DELAY from 'constants/delay.const';
import delayed from 'utils/functions/delayed.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';

import { convertToMoneyAfterVat } from 'reports/utils';

class NewClientsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newClients: [],
    };
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.salonVatRate) {
      this.makeNewClientsTable(this.props.newClientsReport);
    }
  }

  sortArrayBaccordingToArrayA = (a, b) => {
    const IDs = a.map((e) => e.id);
    const newB = [];
    for (let i = 0; i < IDs.length; i += 1) {
      const elementArray = b.filter((s) => s.id === IDs[i]);
      if (elementArray.length > 0) {
        const e = elementArray[0];
        newB.push(e);
      }
    }
    return newB;
  };
  makeNewClientsTable = (data) => {
    const unsortedNewClients = data.stylists.slice();
    const newClients = this.sortArrayBaccordingToArrayA(this.props.stylistIDInCalendarOrder, unsortedNewClients);
    if (newClients.length > 0) {
      for (let i = 0; i < newClients.length; i += 1) {
        if (newClients[i].revenue && newClients[i].new_clients) {
          newClients[i].av_booking_value = newClients[i].revenue / newClients[i].new_clients;
        } else {
          newClients[i].av_booking_value = 0;
        }
      }
    }
    const total = {
      name: 'Salon total',
      new_clients: data.total_new_clients,
      revenue: data.total_revenue,
      av_booking_value: data.total_new_clients ? data.total_revenue / data.total_new_clients : 0,
      booked_online: data.total_booked_online,
      rebooked: data.total_rebooked,
    };
    if (newClients.indexOf(total) < 0) {
      newClients.push(total);
    }
    this.setState({ newClients });

    return newClients;
  };

  render() {
    const { newClients } = this.state;
    if (this.props.newClientsReport && newClients.length === 0) {
      delayed(DELAY.instant, () => this.makeNewClientsTable(this.props.newClientsReport));
    }

    return (
      <div id="new-clients">
        <div className="t-bgr cfix">
          <div className="t-wrap">
            <h2>New Clients</h2>
            <div className="t-exist cfix">
              <NavLink to={`/salon/${this.props.salonId}/communications/clients/first`} onClick={alwaysNoop} className="btn btn-violet btn-report new-clients">
                WHO ARE MY NEW CLIENTS?
              </NavLink>
              <ReactHTMLTableToExcel
                id="test-table-xls-button"
                className="download-xls-button"
                table="table-to-xls-8"
                filename="Retail Sales by Staff Member"
                sheet="tablexls"
                buttonText="DOWNLOAD TO EXCEL"
              />
              <table className="new-client-tbl" id="table-to-xls-8">
                <tbody>
                  <tr>
                    <td colSpan="3">
                      <div className="date-in-tbl-for-export">
                        From <strong>{this.props.startDate}</strong> to <strong>{this.props.endDate}</strong>{' '}
                      </div>
                    </td>
                  </tr>
                  <tr className="t-h first-row">
                    <th className="a3 h" style={{ width: '168px' }}>
                      Staff
                    </th>
                    <th className="a3" style={{ width: '121px' }}>
                      <span className="bubble">
                        <span className="tooltip">
                          <div />
                        </span>
                      </span>
                      <span className="column-title"> New client visits</span>
                    </th>
                    <th className="a3" style={{ width: '121px' }}>
                      <span className="bubble">
                        <span className="tooltip">
                          <div />
                        </span>
                      </span>
                      <span className="column-title">Value of new clients</span>
                    </th>
                    <th className="a3" style={{ width: '121px' }}>
                      <span className="bubble">
                        <span className="tooltip">
                          <div />
                        </span>
                      </span>
                      <span className="column-title"> Average booking value</span>
                    </th>
                    <th className="a3" style={{ width: '121px' }}>
                      <span className="bubble">
                        <span className="tooltip">
                          <div />
                        </span>
                      </span>
                      <span className="column-title"> New clients booked online</span>
                    </th>
                    <th className="a3" style={{ width: '121px' }}>
                      <span className="bubble">
                        <span className="tooltip">
                          <div />
                        </span>
                      </span>
                      <span className="column-title"> New clients rebooked</span>
                    </th>
                    <th style={{ width: 'auto' }} />
                  </tr>
                  {newClients &&
                    newClients.map((st, index) => (
                      <tr className={index !== newClients.length - 1 ? 't-h' : 't-h last-row'} key={st.name}>
                        <td className="stylist-name">{st.name}</td>
                        <td className="t-value">{st['new_clients']}</td>
                        <td className="t-value">
                          <CurrencySign />
                          {convertToMoneyAfterVat(st['revenue'])}
                        </td>
                        <td className="t-value">
                          <CurrencySign />
                          {convertToMoneyAfterVat(st['av_booking_value'])}
                        </td>
                        <td className="t-value">{st['booked_online']}</td>
                        <td className="t-value">{st['rebooked']}</td>
                        <td />
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    currentSalon: { id: salonId },
  } = state;
  return {
    salonId,
  };
}

export default connect(mapStateToProps, null)(NewClientsTable);
